import React from 'react';

export const SingleMenuStepStatus: React.FC<SingleMenuStepStatusProps> = ({ status }) => {
  const textColor = status === 'Approved' ? 'green-300' : 'orange-500';

  return ['Incomplete', 'Unavailable'].includes(status) ? (
    <div className="h-[1rem]"></div>
  ) : (
    <div className="flex space-x-[0.375rem]">
      <img className={'h-[1rem] w-[1rem] '} src={`/assets/icons/colored/${status}_status.svg`} alt=""></img>
      <p className={'content-start text-sm   font-inter text-'.concat(textColor)}>{status}</p>
    </div>
  );
};

interface SingleMenuStepStatusProps {
  status: 'Incomplete' | 'Pending' | 'Approved' | 'Unavailable';
}
